import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export function createStore (state) {
  /* cmiRadarUrl allows development to point to production for radar standard (lite) images
     This env is unnecessary in production which will use local paths if not provided. */

  return new Vuex.Store({
    state: {
      apiKey: state.apiKey?.length ? state.apiKey : null,
      esriKey: state.esriKey?.length ? state.esriKey : null,
      alertsUrl: state.alertsUrl,
      apiUrl: state.apiUrl,
      cmiRadarUrl: state.cmiRadarUrl,
      forecastUrl: state.forecastUrl,
      gisUrl: state.gisUrl,
      radarUrl: state.radarUrl,
      weatherUrl: state.weatherUrl,
      surveyId: state.surveyId,
      panels: {
        alert: null
      }
    },
    mutations: {
      alertPanelAlert (state, alert) {
        state.panels.alert = alert
      }
    },
    actions: {
      tracker ({ commit }, input) {
        if (Vue.$gtag) {
          let meta = {
            event_category: input.category || 'radar-map'
          }
          if (input.type === 'event') {
            if (input.options.label) {
              meta.event_label = input.options.label
            }
            if (input.options.value) {
              meta.value = input.options.value
            }
            Vue.$gtag.event(input.options.action, meta)
          }
        }
      },
      setAlertForPanel ({ commit }, alert) {
        commit('alertPanelAlert', alert)
      }
    },
    getters: {
      apiKey: state => state.apiKey,
      esriKey: state => state.esriKey,
      alertsUrl: state => state.alertsUrl,
      apiUrl: state => state.apiUrl,
      cmiRadarUrl: state => state.cmiRadarUrl,
      forecastUrl: state => state.forecastUrl,
      gisUrl: state => state.gisUrl,
      radarUrl: state => state.radarUrl,
      weatherUrl: state => state.weatherUrl,
      alertPanelAlert: state => state.panels.alert,
      surveyId: state => state.surveyId
    }
  })
}
